import React, { useState } from "react";
import { Container, Text, Tabs, Button, Group, Title, ModalProps } from "@mantine/core";
import IndividualContactusForm from "./IndividualContactusForm";
import CorporateContactUsForm from "./CorporateContactUsForm";
import { closeModal, modals } from "@mantine/modals";


interface ContactUsFormProps {
	data?: {
		activeTab?: "individual" | "corporate",
		remarks?: string,
	}
	onSuccess?: () => void,
	onCancel?: () => void
}

export const ContactUsForm = (props: ContactUsFormProps) => {

	const [activeTab, setActiveTab] = useState(props.data?.activeTab || "individual");
	const handleTabChange = (value: string) => {
		setActiveTab(value as "individual" | "corporate");
	}

	return <Container mih={500}>
		<Title order={4} lh={1}>We'd love to hear from you! If you have any questions or need assistance, please feel free to reach out using the contact details below. Our team will be happy to help and get back to you as soon as possible.</Title>
		<Tabs
			value={activeTab}
			radius="md"
		>
			<Group my={20}>
				<TabsButton onClick={() => handleTabChange("individual")} variant={activeTab === "individual" ? "filled" : "outline"}>Individual</TabsButton>
				<TabsButton onClick={() => handleTabChange("corporate")} variant={activeTab === "corporate" ? "filled" : "outline"}>Corporate</TabsButton>
			</Group>

			<Tabs.Panel value="individual">
				<IndividualContactusForm onSuccess={props.onSuccess} data={props.data} />
			</Tabs.Panel>
			<Tabs.Panel value="corporate">
				<CorporateContactUsForm onSuccess={props.onSuccess} data={props.data} />
			</Tabs.Panel>
		</Tabs>
	</Container>
}


const TabsButton = Button.withProps({
	size: "sm",
	bdrs: 'sm',
	color: "themed.7",
	px: 50
})


export const openContactUsForm = (formProps?: ContactUsFormProps, modalProps?: ModalProps) => {
	const modalId = modals.open({
		closeOnClickOutside: false,
		children: <ContactUsForm {...(formProps || {
			onSuccess: () => {
				closeModal(modalId);
			}
		})} />,
		size: "xl",
		centered: true,
		...(modalProps || {})
	})
	return modalId;
}


